import subscriptionAndNewsletter from './injectSubscriptionAndNewsletter';

export default [
  ...subscriptionAndNewsletter,
];
